<!--
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-06-11 18:59:45
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-06-21 11:28:01
 * @FilePath: \website\src\components\element\options\comp\cpt-default.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <t-form-item label="默认值类型">
        <t-select clearable v-model="attribute.defaultValueType" @change="defaultValueTypeHandler" size="small">
            <t-option v-for="(item, index) in filteredArr" :key="index + item.type" :label="item.label"
                :value="item.type" clearable filterable />
        </t-select>
    </t-form-item>
    <t-form-item v-show="attribute.defaultValueType !== 4"
        :label="attribute.daterange ? `开始日期${defaultValueLabel}` : `${defaultValueLabel}`"
        v-if="attribute.defaultValueType != null">
        <t-input autofocus v-model="attribute.defaultValue"
            :placeholder="attribute.daterange ? `请输入开始日期${defaultValueLabel}` : `请输入${defaultValueLabel}`"
            @click="formulaFun(attribute, '')" />
    </t-form-item>
    <t-form-item v-show="attribute.defaultValueType !== 4" :label="`结束日期${defaultValueLabel}`"
        v-if="attribute.defaultValueType != null && attribute.daterange">
        <t-input autofocus v-model="attribute.defaultValueEnd" :placeholder="`请输入结束日期${defaultValueLabel}`"
            @click="formulaFun(attribute, 'end')" />
    </t-form-item>
    <cpt-fun ref="cptFunShow" />
</template>

<script setup>
import { reactive, computed, defineProps, onMounted, ref } from 'vue'
import CptFun from "@/components/element/options/comp/cpt-fun"; // 函数公共弹窗
const props = defineProps({
    attribute: Object,
    currentCpt: Object,
    cacheComponents: Array,
    refMap: Object
})
const cptFunShow = ref()
const defaultTypeArray = reactive([
    {
        type: 0,
        label: '固定值'
    },
    {
        type: 1,
        label: 'URL参数key'
    },
    {
        type: 2,
        label: '临时缓存Key'
    },
    {
        type: 3,
        label: '公式'
    }, {
        type: 4,
        label: '默认选中第一项'
    }
])
const filteredArr = computed(() => {
    if (props.currentCpt.cptKey === "cpt-date-picker" || props.currentCpt.cptKey === "cpt-text" || props.currentCpt.cptKey === "cpt-date-picker-mobile") {
        return defaultTypeArray;
    } else {
        return defaultTypeArray.filter(item => item.label !== "公式");
    }
});

const defaultValueTypeHandler = (type) => {
    // if (props.attribute.defaultValueType == 4) {
        // props.attribute.defaultValueCurrentID = `[ID]${props.currentCpt.id}`
    // }
}
// 下拉框回显label
let defaultValueLabel = computed(() => {
    let defaultValueObject = defaultTypeArray.find(x => x.type == props.attribute.defaultValueType)
    return defaultValueObject.label
})
onMounted(() => {
    console.log(props.attribute, '77777')
})

const formulaFun = (val, type) => {
    // 如果是公式,就打开公共的函数弹框
    if (val.defaultValueType == '3') {
        let items = JSON.parse(JSON.stringify(props.attribute))
        cptFunShow.value.opened(props, type, items)
    }
}
</script>